import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllStations } from '../../api/buoyAPI';
import BuoyCard from './BuoyCard';
import { addBuoyFailure, addBuoySuccess, createBreakFailure, formBuoy, formName, formTime } from '../../redux/breakSlice';
import { createNewBreak } from '../../api/breakAPI';
import { useNavigate } from 'react-router-dom';

function BreakForm() {
	// State/Hooks =========================================================================================================
	const breaksState = useSelector(state => state.breaks)
	const userID = useSelector(state => state.user.user._id)
	const token = useSelector(state => state.user.token)
	const dispatch = useDispatch();
	const navigate = useNavigate();

	//Get Data =========================================================================================================
	React.useEffect(() => {
		dispatch(getAllStations(token))
	},[dispatch, token])

	//Handlers =========================================================================================================
	const handleAdd = () => {
		if (breaksState.form.currentStation === null) {
			dispatch(addBuoyFailure())
		} else {
			let targetID = breaksState.form.currentStation.split("-")[0];
			let station = breaksState.allStations.find(station => station.id === targetID);
			if (station !== undefined) {
				dispatch(addBuoySuccess(station));
			} else {
				dispatch(addBuoyFailure())
			}
		}
	}

	const validate = () => {
		let valid = true;
		
		if (breaksState.form.name === "") {
			valid = false
			dispatch(createBreakFailure({error: "Please input a name for this break, brah"}))
			return valid;
		} else if (breaksState.form.selectedStations === undefined) {
			valid = false
			dispatch(createBreakFailure({error: "Please select at least one buoy for this break, brah"}))
			return valid;
		}

		return valid
	}

	const handleSubmit = (event) => {
		event.preventDefault();
	
		let submitData = {
			name: breaksState.form.name,
			timezone: breaksState.form.timezone,
			buoys: [
				...breaksState.form.selectedStations
			],
			notes: "Enter notes here",
			owner: userID
		}

		if (validate()) {
			console.log(submitData)
			dispatch(createNewBreak({submitData, token, navigate}))
		}
	}

	//DOM Render =========================================================================================================
	return(
		<div className="content">
			<h1>Create a New Break</h1>
			
			<div className="form shadow-lg mobile-w-10-12">
				<p className='description m-3'>
					To create a new break, add buoy stations below to associate with this break. 
					The stations you add here will appear whenever you view your break in the "Breaks" tab
				</p>

				<label htmlFor='name' className='form-label'>Name of Break</label>
				<input 
					type="text" 
					name="name" 
					id="name" 
					onChange={(event) => dispatch(formName(event.target.value))} 
					placeholder="Enter Name for New Break" 
					className='w-80 mobile-w-11-12'
				/>

				<label htmlFor='timezone' className='form-label'>Time Zone</label>
				<select
					type="text" 
					name="timezone" 
					id="timezone" 
					defaultValue={"PST"}
					onChange={(event) => dispatch(formTime(event.target.value))} 
					placeholder="Enter Name for New Break" 
					className='w-80 mobile-w-11-12'
				>
					<option value="PST">PST</option>
					<option value="CST">CST</option>
					<option value="MST">MST</option>
					<option value="EST">EST</option>
					<option value="HST">HST</option>
					<option value="AKST">AKST</option>
				</select>
				
				<label htmlFor='stations' className='form-label'>Add a Buoy</label>
				<input 
					name="stations" 
					id="stations" 
					className='form-select w-80 mobile-w-11-12' 
					list="stationsList" 
					placeholder='Type station name or id' 
					onChange={(event) => dispatch(formBuoy(event.target.value))}
					value={breaksState.form.currentStation}
				/>
				<datalist id="stationsList">
					{breaksState.allStations.map((station) => {
						return <option key={station.id}>{station.id}-{station.name}</option>
					})}
				</datalist>

				<div>
					{breaksState.currentStation ? 
						<BuoyCard 
							name={breaksState.currentStation.name}
							id={breaksState.currentStation.id}
							lat={breaksState.currentStation.lat}
							lon={breaksState.currentStation.lon}
							onwer={breaksState.currentStation.onwer}
							elev={breaksState.currentStation.elev}
						/> : ""
					}
				</div>
				<button className={`${breaksState.form.currentStation.length > 0 ? "block m-auto btn-primary" : "block m-auto btn-secondary"}`} onClick={handleAdd}>Add Station to Break</button>
				<p className='mt-5 text-red-500 font-bold'>{breaksState.form.error}</p>
				<br></br>
			</div>

			<h2 className='mt-6'>Selected Buoys</h2>
			<p className='description m-3'>
				These are the buoys you have selected for this break. Click to remove a buoy you do not want
			</p>
			<div className='flex flex-row flex-wrap justify-center space-between m-3'>
				{breaksState.form.selectedStations.map(station => {
					return <BuoyCard 
							key={station.id}
							name={station.name}
							id={station.id}
							lat={station.lat}
							lon={station.lon}
							owner={station.owner}
							elev={station.elev}
						/>
				})}
			</div>

			<button onClick={(event) => handleSubmit(event)} className='btn-primary mb-10'>Create Break</button>
		</div>
	)
}

export default BreakForm;